
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16","cy":"16","r":"11.5","fill":"#4FA2B7","stroke":"#4FA2B7"}}),_c('circle',{attrs:{"cx":"16","cy":"16","r":"15.5","stroke":"#4FA2B7"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/stepperSVGs/stepperIconCurrent.svg